export default {
  state: {
    ids: null,
    accountId: null,
    memberId: null,
    email: null,
    partner: null,
    configUserKeepSignIn: null
  },
  mutations: {
    SET_USER(state, user) {
      state.ids = user.ids;
      state.accountId = user.accountId;
      state.memberId = user.memberId;
      state.email = user.email;
      state.partner = user.partner;
      state.configUserKeepSignIn = user.configUserKeepSignIn
    },
  },
  actions: {
    setUser({ commit }, { ids, memberId, accountId, email, partner, configUserKeepSignIn }) {
      commit('SET_USER', { ids, memberId, accountId, email, partner, configUserKeepSignIn });
    },
  },
  getters: {
    userIds: (state) => state.ids,
    userAccountId: (state) => state.accountId,
    memberId: (state) => state.memberId,
    userEmail: (state) => state.email,
    partner: (state) => state.partner,
    configUserKeepSignIn: (state) => state.configUserKeepSignIn,
  },
};
